import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import 'vant/lib/index.css'
import {Swipe,
    SwipeItem,
    Loading,
    CountDown,
    List
} from 'vant'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'

const baseSize = 37.5;
function setRem() {
    const width = document.documentElement.clientWidth
    let scale = 0
    if(width >= 768) {
        scale = width / 1920
    }else {
        scale = width / 375
    }
    document.documentElement.style.fontSize = (baseSize * Math.min(scale, 2)) + 'px';
}
window.onresize = setRem;
setRem();

const app = createApp(App)
app.use(router)
app.use(Swipe)
app.use(SwipeItem)
app.use(Loading)
app.use(CountDown)
app.use(List)
app.use(ElementPlus)
app.mount('#app')
